import React from 'react';
import { TextField } from '@mui/material';
import { SurveyComponent } from '../../../../models/SurveyTemplates';

interface EmailInputFieldProps {
    field: SurveyComponent;
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
}

const EmailInputField: React.FC<EmailInputFieldProps> = ({
    field,
    value = '',
    onChange,
    disabled = false
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(event.target.value);
        }
    };

    return (
        <TextField
            fullWidth
            type="email"
            label={field.label}
            placeholder={field.placeholder}
            value={value}
            onChange={handleChange}
            disabled={disabled}
            required={field.required}
            helperText={field.description}
            variant="outlined"
            margin="normal"
            inputProps={{
                minLength: field.properties?.minLength,
                maxLength: field.properties?.maxLength,
            }}
        />
    );
};

export default EmailInputField;
